module.exports = __webpack_public_path__ + "media/images/niger-454a1825a2c2ff21f8a24806c7c7db69.png";